import axios from 'axios';
import { API_BASE_URL } from '../../constants';

type AboutUsHeader = {
  id: string;
  Title: string;
  Points: string[];
};

export type AboutUsDescription = {
  Title: string;
  Subtitle: string;
  cards: AboutUsDescriptionCard[];
};
export type AboutUsDescriptionCard = {
  id: number;
  Description: string;
};

export type TeamDeliverables = {
  id: number;
  Title: string;
  Subtitle: string;
  Cards: TeamDeliverablesCard[];
};
export type TeamDeliverablesCard = {
  id: number;
  Name: string;
  Description: string;
  Icon: string;
};
export type AboutUsProvide = {
  Title: string;
  Subtitle: string;
  Image: string;
  cards: AboutUsProvideCard[];
};

export interface AboutUsProvideCard {
  id: number;
  Title: string;
  Description: string;
}

export type AboutUsTeam = {
  id: number;
  Title: string;
  Team: {
    id: number;
    Name: string;
  }[];
};

export type AboutUsContact = {
  Title: string;
  Subtitle: string;
};

export type DataType = {
  aboutUsHeader: AboutUsHeader;
  description: AboutUsDescription;
  teamDeliverables: TeamDeliverables;
  aboutUsProvide: AboutUsProvide;
  team: AboutUsTeam;
  aboutUsContact: AboutUsContact;
};

export const fetchAboutUsPageContent = async (): Promise<DataType> => {
  const res = await axios.get(`${API_BASE_URL}/about_us`);
  return res.data.data;
};
